export default {
    companyName: "",
    accountNumber: null,
    routingNumber: null,
    paymentMethodId: null,
}